import type { TrackerInterface, TrackingProperties } from '../interfaces/trackerInterface';
import * as trackerInterface from '../interfaces/trackerInterface';
import { getLogger } from '../logger';
import events, { type MixPanelEventsType } from './events';

const log = getLogger('tracker');

class Tracker {
  trackerInterface: TrackerInterface;
  dynamicDefaultPropertiesCreator: () => TrackingProperties | undefined;
  events: MixPanelEventsType;
  dateLastActiveTracked: number;
  defaultProperties: TrackingProperties;
  trackEventTTI: TrackerInterface['trackEventTTI'];
  userId: string | null | undefined;

  constructor(trackerInterfaceParam: TrackerInterface) {
    this.trackerInterface = trackerInterfaceParam;
    this.dynamicDefaultPropertiesCreator = trackerInterfaceParam.dynamicDefaultProperties
      ? trackerInterfaceParam.dynamicDefaultProperties
      : () => undefined;
    this.events = events;
    this.dateLastActiveTracked = 0;
    this.defaultProperties = {};
    this.trackEventTTI = trackerInterfaceParam.trackEventTTI;
  }

  identify = (userId: string | undefined | null) => {
    this.userId = userId || 'unknown';
    this.trackerInterface.identify(this.userId);
    const userIdVerify = this.trackerInterface.getIdentity();
    if (!assert(userIdVerify === this.userId, 'tracker failed to identify user')) {
      this.userId = undefined;
    }
  };

  setDefaultProperties = (properties: TrackingProperties) => {
    this.defaultProperties = properties;
  };

  setUserId = (userId: string | undefined | null) => {
    this.userId = userId;
  };

  timeEvent = (event: string) => {
    this.trackerInterface.timeEvent(event);
  };

  track = (event: string, properties?: TrackingProperties) => {
    try {
      if (this.userId) {
        const defaultProps = { ...this.defaultProperties, ...this.dynamicDefaultPropertiesCreator() };
        const allProperties = { ...defaultProps, ...properties };
        log.log('track: ', event, '\nexplicit props: ', properties, '\ndefault props:', defaultProps);
        this.trackerInterface.track(event, allProperties);
      } else {
        log.warn(`track: '${event}'\nreject to track unidentified user\ncall 'identify(<userId>)' first`);
      }
    } catch (e) {
      log.error(`tracking failed: ${e}`);
    }
  };

  trackActive(properties: TrackingProperties = {}) {
    const dateNow = Date.now();
    if (dateNow - this.dateLastActiveTracked > 15 * 60 * 1000) {
      // once per 15 mins
      if (this.defaultProperties.qcs_id !== 'unknown') {
        this.track(this.events.active, properties);
        this.dateLastActiveTracked = dateNow;
      }
    }
  }

  resetActiveTimestamp() {
    this.dateLastActiveTracked = 0;
  }

  updateProfile(props: TrackingProperties) {
    return this.trackerInterface.updateProfile(props);
  }
}

const gTracker = new Tracker(trackerInterface);

export { gTracker as default };
